import { CacheConfig, HttpRequestConfig, HttpResponse } from '@/utils/http-utils';
import httpService from '@/services/http.service';
import StringUtils from '@/utils/string-utils';
import { EnvInfo } from '@ol/ol-ui-core';
import WindowUtils from '@/utils/window-utils';

class ConfigService {
  private configs: { [key: string]: string } = null;
  public getCachedConfigs(): any {
    return this.configs;
  }
  public async initLoadConfigsIfNeeded(): Promise<any> {
    if (this.configs) return this.configs;
    const cfgs: any = await this.getConfigs();
    Object.keys(cfgs || {}).forEach((key: any) => {
      let url: string = cfgs[key];
      url = this.replaceVaraiblesRecusively(url, cfgs);
      cfgs[key] = url;
    });
    this.configs = cfgs;
    return cfgs;
  }
  public async getConfigs(): Promise<any> {
    const cacheName: string = 'OLIQ_Configs';
    const cacheKey: string = 'configs';
    const cacheConfig: CacheConfig = {
      name: cacheName,
      key: cacheKey,
      options: {
        cacheKeepOneKeyOnly: false,
        timeToLive: -1,
      },
    };
    const config: HttpRequestConfig = {
      cache: cacheConfig,
    };
    const url = process.env.VUE_APP_CONFIG_JSON_URL || '/oliq/assets/configs/config.json';
    const endpointsResponse: HttpResponse<any> = await httpService.get<any>(url, config, true);
    return endpointsResponse.data;
  }

  public async getConfig(key: string): Promise<string> {
    let endpoints: { [key: string]: string } = this.getCachedConfigs();
    if (!endpoints) {
      endpoints = await this.initLoadConfigsIfNeeded();
    }
    if (!endpoints) return null;
    const value: string = this.replaceVaraiblesRecusively(endpoints[key], endpoints);
    return value;
  }
  public getConfigFromCachedConfigs(key: string): string {
    const endpoints: { [key: string]: string } = this.getCachedConfigs();
    if (!endpoints) return null;
    const value: string = this.replaceVaraiblesRecusively(endpoints[key], endpoints);
    return value;
  }

  private replaceVaraiblesRecusively(str: string, values: { [key: string]: string }): string {
    return StringUtils.replaceVaraiblesRecusively(str, '{', '}', values);
  }
  public async getEnvInfo(): Promise<EnvInfo> {
    const envConfig: any = await this.getConfigs();
    const env: string = envConfig.siteEnv;
    let siteInfoUrl: string = envConfig.siteInfo;
    siteInfoUrl = siteInfoUrl.replace('{hostName}', WindowUtils.getHostName());
    const envInfo: EnvInfo = { env, siteInfoAPIEndpoint: siteInfoUrl };
    return envInfo;
  }
}
// Export a singleton instance in the global namespace
export const configService = new ConfigService();
